import React, { useState, useEffect } from "react";
import { IconButton, Tooltip, makeStyles } from "@material-ui/core";
import { Mic, MicOff } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    backgroundColor: "#f1f5f9",
    color: "#94a3b8",
    borderRadius: 16,
    padding: 10,
    margin: 4,
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#e2e8f0",
      transform: "scale(1.05)",
    },
  },
  iconButtonActive: {
    backgroundColor: "#ef4444",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#dc2626",
    },
    animation: "$pulse 1.5s infinite",
  },
  "@keyframes pulse": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(239, 68, 68, 0.4)",
    },
    "70%": {
      boxShadow: "0 0 0 10px rgba(239, 68, 68, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(239, 68, 68, 0)",
    },
  },
}));

const VoiceInput = ({ onSpeechResult, onSpeechInterim, onSpeechStart, enableRealtime = false }) => {
  const classes = useStyles();
  const [isListening, setIsListening] = useState(false);
  const [recognition, setRecognition] = useState(null);

  useEffect(() => {
    // Check browser support
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    
    if (SpeechRecognition) {
      const recognitionInstance = new SpeechRecognition();
      recognitionInstance.continuous = false;
      recognitionInstance.lang = 'it-IT';
      recognitionInstance.interimResults = enableRealtime;
      recognitionInstance.maxAlternatives = 1;

      recognitionInstance.onstart = () => {
        setIsListening(true);
        if (onSpeechStart) onSpeechStart();
      };

      recognitionInstance.onend = () => {
        setIsListening(false);
      };

      recognitionInstance.onresult = (event) => {
        let finalTranscript = '';
        let interimTranscript = '';

        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            finalTranscript += event.results[i][0].transcript;
          } else {
            interimTranscript += event.results[i][0].transcript;
          }
        }

        if (finalTranscript && onSpeechResult) {
          onSpeechResult(finalTranscript);
        } else if (interimTranscript && onSpeechInterim) {
          onSpeechInterim(interimTranscript);
        }
      };

      recognitionInstance.onerror = (event) => {
        console.error("Speech recognition error", event.error);
        setIsListening(false);
      };

      setRecognition(recognitionInstance);
    }
  }, [onSpeechResult, onSpeechInterim, onSpeechStart, enableRealtime]);

  const toggleListening = () => {
    if (!recognition) {
      alert("Il tuo browser non supporta il riconoscimento vocale.");
      return;
    }

    if (isListening) {
      recognition.stop();
    } else {
      recognition.start();
    }
  };

  if (!recognition) {
    return null; // Don't render if not supported
  }

  return (
    <Tooltip title={isListening ? "Sto ascoltando..." : "Dettatura vocale"}>
      <IconButton
        onClick={toggleListening}
        className={`${classes.iconButton} ${isListening ? classes.iconButtonActive : ""}`}
        size="small"
      >
        {isListening ? <MicOff style={{ fontSize: 20 }} /> : <Mic style={{ fontSize: 20 }} />}
      </IconButton>
    </Tooltip>
  );
};

export default VoiceInput;
